import {
    TOGGLE_MODAL,
    SELECT_TABLE_ITEM,
    TRACKED_BUSINESSES,
    REMOVE_TRACKED_BUSINESS,
    SAVE_BUSINESS_DATA,
    SET_COUNTRIES,
    COMMISSION_CONFIG,
    REFRESHER
} from './app.type'

export const toggleModal = (data: boolean) => ({
    type: TOGGLE_MODAL,
    payload: data
})

export const selectTableItem = (data: any) => ({
    type: SELECT_TABLE_ITEM,
    payload: data
})

export const storeTrackedBusinesses = (data: any[]) => ({
    type: TRACKED_BUSINESSES,
    payload: data
})

export const removeTrackedBusiness = (id: any) => ({
    type: REMOVE_TRACKED_BUSINESS,
    payload: id
})

export const saveBusinessData = (data: any[]) => ({
    type: SAVE_BUSINESS_DATA,
    payload: data
})

export const setCountries = (data: any[]) => ({
    type: SET_COUNTRIES,
    payload: data
})

export const storeCommissionConfig = (data: any[]) => ({
    type: COMMISSION_CONFIG,
    payload: data
})

export const updateRefresher = () => ({
    type: REFRESHER
})